<!-- get api key @: https://developers.google.com/maps/documentation/javascript/get-api-key -->

<template>
  <div class="googlemaps">
    <!-- render map -->
  </div>
</template>

<script>
export default {
  name: "googlemaps",
  props: {
    results: {
      type: Array,
    },
  },
  data() {
    return {
      init: false, // reset: avoid flashing
      map: undefined,
      markers: {},
      defaults: {
        fullscreenControl: true,
        mapTypeControl: false,
        scrollwheel: false,
        streetViewControl: false,
        zoom: 5,
        maxZoom: 14,
        zoomControl: true,
        zoomControlOptions: {
          position: 3, // top right
        },
        center:
          this.$parent.country === "US"
            ? { lat: 39.635307, lng: -101.337891 }
            : { lat: 59.951455, lng: -101.337891 },
        styles: [
          {
            featureType: "poi",
            stylers: [{ visibility: "off" }],
          },
        ],
        zIndex: 100,
        // draggable: !navigator.userAgent.match(/Mobi/) // false on touch devices or draggable: !("ontouchend" in document)
      },
      icon: {
        black: "@/assets/images/icon-ga-marker-black.png",
        red: "@/assets/images/icon-ga-marker-red.png",
      },
    };
  },
  watch: {
    results(val) {
      !val.length ? this.reset() : this.render();
    },
    "$parent.marker"(val) {
      this.map.panTo({ lat: val.store.latitude, lng: val.store.longitude });

      this.infowindow = this.infowindow || new google.maps.InfoWindow();
      this.infowindow.setContent(
        `<div style="padding: .325rem 1.5rem"><p class="text-center" style="margin: 0"> <strong>${val.store.name}</strong> <br /> ${val.store.location.address}</p><div>`
      );
      this.infowindow.open(this.map, this.markers[val.store.store_code]);

      for (let prop in this.markers) {
        this.markers[prop].icon.url = this.icon.black;
      }
      this.markers[val.store.store_code].icon.url = this.icon.red;

      this.defaults.zIndex += 1;
      this.markers[val.store.store_code].setZIndex(this.defaults.zIndex);
    },
    "$root.mode": {
      handler(val) {
        this.defaults.zoomControl = !["xs", "sm"].includes(val);
        // this.defaults.fullscreenControl = ['xs', 'sm'].includes(val);
      },
      immediate: true,
    },
  },
  methods: {
    reset() {
      this.map = new google.maps.Map(this.$el, this.defaults);
      this.location(); // add location ui control to the map
    },
    render() {
      let bounds = new google.maps.LatLngBounds();

      // reset: avoid flashing
      if (!this.init) {
        this.init = true;
        this.reset();
      }
      // end

      for (let prop in this.markers) {
        this.markers[prop].setMap(null);
      }

      for (let value of this.results) {
        let marker = new google.maps.Marker({
          position: new google.maps.LatLng(value.latitude, value.longitude),
          map: this.map,
          icon: {
            url: this.icon.black,
            scaledSize: new google.maps.Size(30, 44),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(15, 44),
          },
        });

        // retain markers
        this.markers[value.store_code] = marker;

        // extend the bounds to include each marker's position
        bounds.extend(marker.position);

        // add listener
        google.maps.event.addListener(
          marker,
          "click",
          ((marker) => {
            return () => {
              // this.infowindow = this.infowindow || new google.maps.InfoWindow();
              // this.infowindow.setContent(`<p class="text-center"> <strong>${value.name}</strong> <br /> ${value.location.address}</p>`);
              // this.infowindow.open(this.map, marker);

              this.$emit("update:marker", {
                active: value.store_code,
                store: value,
              });
            };
          })(marker)
        );
      }

      // now fit the map to the newly inclusive bounds
      this.map.fitBounds(bounds);
    },
    location() {
      let control = document.createElement("div");

      let button = document.createElement("button");
      button.style.backgroundColor = "#fff";
      button.style.border = "none";
      button.style.borderRadius = "2px";
      button.style.outline = "none";
      button.style.width = "28px";
      button.style.height = "28px";
      button.style.boxShadow = "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px";
      button.style.cursor = "pointer";
      button.style.margin = "10px";
      button.style.padding = "0";
      button.title = "location";
      control.appendChild(button);

      let div = document.createElement("div");
      div.style.margin = "5px";
      div.style.width = "18px";
      div.style.height = "18px";
      div.style.backgroundImage =
        "url(@/assets/images/googlemap-location-sprite@2x.png)";
      div.style.backgroundSize = "180px 18px";
      div.style.backgroundPosition = "0 0";
      div.style.backgroundRepeat = "no-repeat";
      button.appendChild(div);

      button.addEventListener("click", () => {
        this.$parent._position();
      });

      google.maps.event.addListener(this.map, "center_changed", () => {
        div.style["background-position"] = "0 0";
      });

      // google.maps.event.addListener(this.map, 'idle', () => {
      //    console.log('idle');
      // });

      this.$parent.$on("navigator:geolocation", () => {
        setTimeout(() => {
          div.style["background-position"] = "-144px 0";
        }, 500);
      });

      control.index = 1;
      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(control);
    },
  },
  mounted() {
    this.defaults.zoom = ["xs", "sm"].includes(this.$root.mode) ? 4 : 5; // do not move this to `watch`

    if (this.$parent.country === "CA") {
      this.defaults.zoom = 4;
    }

    $.getScript(
      "https://maps.googleapis.com/maps/api/js?v=3.39&key=AIzaSyCVeO_Gj3viUK1UfZTWJMqLJcJOlVOK9Wc&libraries=places",
      (data, textStatus, jqxhr) => {
        this.map = new google.maps.Map(this.$el, this.defaults);
        this.location(); // add location ui control to the map
        this.$parent._autocomplete();
      }
    );
  },
};
</script>

<style lang="scss" scoped>
.googlemaps {
  width: 100%;
  height: 280px;

  @media (min-width: 768px) {
    height: 380px;
  }

  @media (min-width: 992px) {
    height: 100%;
  }
}
</style>